import * as React from "react";
const SvgFiRrWorkflowAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-workflow-alt_svg__a)">
      <path
        fill="#062147"
        d="M20.5 15.12V8.765a2.9 2.9 0 0 0 1.076-.675l1.564-1.564a2.937 2.937 0 0 0 0-4.151L21.576.81a2.937 2.937 0 0 0-4.151 0l-1.564 1.564a2.9 2.9 0 0 0-.675 1.076H8.864C8.388 1.477 6.619 0 4.501 0A4.504 4.504 0 0 0 0 4.5c0 1.953 1.258 3.602 3 4.224V16h-.199A2.804 2.804 0 0 0 0 18.8v2.4C0 22.744 1.257 24 2.801 24H5.2C6.744 24 8 22.744 8 21.2v-2.4C8 17.256 6.744 16 5.2 16H5V8.949a4.49 4.49 0 0 0 3.895-3.501h6.29c.144.399.366.767.675 1.076l1.564 1.564c.314.314.683.533 1.075.675v6.357c-2 .457-3.5 2.242-3.5 4.379 0 2.48 2.019 4.5 4.5 4.5s4.5-2.02 4.5-4.5c0-2.137-1.5-3.922-3.5-4.38zM6 18.8v2.4a.8.8 0 0 1-.8.8H2.801A.8.8 0 0 1 2 21.2v-2.4c0-.441.359-.8.801-.8H5.2a.8.8 0 0 1 .8.8M4.5 7A2.503 2.503 0 0 1 2 4.5C2 3.122 3.121 2 4.5 2S7 3.122 7 4.5 5.879 7 4.5 7m12.774-1.89a.93.93 0 0 1-.273-.662c0-.25.097-.485.273-.662l1.564-1.564a.93.93 0 0 1 .662-.274c.25 0 .484.097.661.274l1.564 1.564a.934.934 0 0 1 0 1.324l-1.564 1.564a.96.96 0 0 1-1.323 0zM19.5 22a2.5 2.5 0 0 1-2.5-2.5c0-1.38 1.121-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.121 2.5-2.5 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-workflow-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWorkflowAlt;
